<template>
  
    <content-header
        icona="fas fa-question-circle"
        titolo="Questionari"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

            <!-- *** GRIGLIA QUESTIONARI *** -->
            <div class="card" v-if="mostraGrigliaQuestionari">
                <div class="card-body">

                    <button type="button" class="btn btn-dark" @click="GetListQuestionari()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;
                    <button type="button" class="btn btn-success" @click="AttivaEditQuestionario">
                        <i class="fas fa-plus"></i>&nbsp;Nuovo Questionario
                    </button>&nbsp;
                    <br /><br />

                    <div class="d-flex justify-content-start">
                        <div class="form-group mx-2 " style="width:350px">
                            <label>Ricerca testuale</label>
                            <input type="text" class="form-control form-control-sm" placeholder="cerca per ..." v-model="reqGrigliaQuestionari.Testuale" @keyup.enter="GetListQuestionari" />
                        </div>
                        
                        <div class="from-group mx-2">
                            
                            <a class="btn btn-sm btn-dark" @click="AzzeraFiltri" style="margin-top:30px;">
                            <i class="fas fa-times"></i>&nbsp;Azzera
                            </a>&nbsp;
                            <a class="btn btn-sm btn-info" @click="GetListQuestionari" style="margin-top:30px;" >
                            <i class="fas fa-search"></i>&nbsp;Cerca
                            </a>
                        </div>
                    </div>  
                    <div class="d-flex justify-content-start">
      

                    </div>
                    
                    
                    <br/>
                    <griglia-facile
                        :colonne-header="g_colonneHeader"
                        :colonne="g_colonne"
                        :colonneNoOrder="g_colonneNoOrder"
                        :colonneAlign="g_colonneAlign"
                        :comandi="g_comandi"
                        :mostraPager="true"
                        classi-table="table-sm table-hover table-custom"
                        :dati="dtQuestionari"
                        :queryLength="g_queryLength"
                        :currentPage="g_currentPage"
                        
                        @Seleziona="SelectQuestionario"
                        @Cancella="DelElemQuestionari"
                        @Ordina="OrdinaGriglia"
                        
                        @CambiaElementi="CambiaElementi"
                        @Precedente="PaginaPrecendente"
                        @Successiva="PaginaSuccessiva"
                        @CambiaPagina="CambiaPagina"
                       

                        fontawesome="standard"

                        ></griglia-facile>


                </div>
            </div>


             <!-- *** EDIT QUESTIONARIO *** -->
            <div class="card" v-if="mostraEditQuestionario">
                <div class="card-header">
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaQuestionario(true)">Salva</button>&nbsp;
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaQuestionario(false)">Salva e Chiudi</button>
                </div>
                <div class="card-body">
                    <form autocomplete="off">

                        <messaggio-standard 
                            :mostraMessaggio="mostraMessaggio"
                            :alertClass="alertClass"
                            :alertIcon="alertIcon"
                            :alertIconSpin="alertIconSpin"
                            :alertMessaggio="alertMessaggio"
                            fontawesome="standard"
                            ></messaggio-standard>
                       

                        <div class="row rigaSezioneForm">
                            <div class="col-md">
                                <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Tipo</label>
                                    <select class="form-control" v-model="oQuestionario.que_tipo">
                                        <option value="1">Valutazione ingresso</option>
                                        <option value="2">Valutazione finale</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Nome</label>
                                    <input type="text" v-model="oQuestionario.que_nome" class="form-control" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-10">
                                <div class="form-group">
                                    <label>Descrizione</label>
                                    <textarea v-model="oQuestionario.que_testo" class="form-control" ref="desc"></textarea>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <br />
                                <button type="button" class="btn btn-primary"><i class="fas fa-link"></i> Crea link</button>
                            </div>
                        </div>
                        
                        <br/>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label><i class="fas fa-eye text-success"></i> Visualizza il quiz</label>
                                    <input type="checkbox" v-model="oQuestionario.que_visib" class="form-check-input ms-2" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label><i class="fas fa-user-check text-warning"></i> Permetti quiz</label>
                                    <input type="checkbox" v-model="oQuestionario.que_quiz" class="form-check-input ms-2" />
                                </div>
                            </div>
                        </div>

                        <div class="row rigaSezioneForm mt-4">
                            <div class="col-md">
                                <i class="fas fa-wrench text-primary"></i>&nbsp;Regole test
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Numero domande da mostrare</label>
                                    <input type="numeric" v-model="oQuestionario.que_domande" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>Risposte corrette per passare il test</label>
                                <input type="numeric" v-model="oQuestionario.que_risp_passaggio" class="form-control" />
                            </div>
                        </div>


                        <div class="row rigaSezioneForm mt-4">
                            <div class="col-md">
                                <i class="fas fa-question-circle text-primary"></i>&nbsp;Domande
                            </div>
                        </div>

                        <br />

                        <a name="topDomande"></a>
                        <button class="btn btn-outline-success" type="button"  @click="NuovaDomanda"><i class="fas fa-plus"></i>&nbsp;Nuova domanda</button>
                        <br /><br />

                        <!-- ****** ELENCO DOMANTE E RISPOSTE ****** -->
                        <template v-for="(d, ndx) in oQuestionario.domande" :key="ndx">
                            <div class="row bg-white shadow-sm rounded" style="margin-bottom: 15px; padding: 10px;">
                                <div class="col-md-10">
                                    <div class="row">
                                        <div class="col-md-1">
                                            <button class="btn btn-outline-blue btn-icon" type="button">
                                                {{ndx+1}}
                                            </button>
                                        </div>
                                        <div class="col-md-11">
                                            <textarea class="form-control bg-gray-200" style="margin-bottom:5px;" v-model="d.qdo_testo"></textarea>
                                        </div>
                                    </div>
                                    
                                    <div class="row" v-for="(r, ndx_r) in d.risposte" :key="ndx_r" style="margin-bottom:5px;">
                                        <div class="col-md-1">&nbsp;</div>
                                        <div class="col-md-1">
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" :name="'grp_' + ndx" :id="'chk_' + r.qri_idr" v-model="r.qri_valore" :value="true"  />
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <textarea class="form-control" v-model="r.qri_testo"></textarea>
                                        </div>
                                        <div class="col-md-2">
                                            <button type="button" class="btn btn-outline-warning btn-sm" title="Elimina risposta" @click="EliminaRisposta(ndx, ndx_r)"><i class="fas fa-trash fa-fw"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2"> 
                                    <button type="button" class="btn btn-outline-warning btn-sm" title="Elimina domanda" @click="EliminaDomanda(ndx)"><i class="fas fa-trash fa-fw"></i></button>
                                    <button type="button" class="btn btn-outline-success btn-sm" title="Nuova risposta" @click="NuovaRisposta(d.qdo_idd, ndx)"><i class="fas fa-plus fa-fw"></i></button>
                                    <button type="button" class="btn btn-outline-info btn-sm" title="Up" @click="OrdinaDomanda(d, 'up', ndx)"><i class="fas fa-arrow-up fa-fw"></i></button>
                                    <button type="button" class="btn btn-outline-info btn-sm" title="Dn" @click="OrdinaDomanda(d, 'dn', ndx)"><i class="fas fa-arrow-down fa-fw"></i></button>
                                </div>
                            </div>
                            <a name="aDomBottom"></a>
                        </template>

                        <br /><br />
                        <button class="btn btn-outline-success" type="button"  @click="NuovaDomanda"><i class="fas fa-plus"></i>&nbsp;Nuova domanda</button>
                        <br /><br />



                    </form>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaQuestionario(true)">Salva</button>&nbsp;
                    <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaQuestionario(false)">Salva e Chiudi</button>
                </div>
            </div>
           

           
        </div>
    </div>

    <iframe id="iFrameDn" name="iFrameDn" src="about:blank" style="display:none"></iframe> 
    
</template>

<script>
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'QuestionariView',
    components: {
        ContentHeader, GrigliaFacile, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtQuestionari: [],

            //Impostazioni griglia QUESTIOANRI
            g_colonne: ['que_idq', 'qti_descrizione', 'que_nome', 'que_data', 'que_visib'],
            g_colonneHeader: ['Id', 'Tipo', 'Nome', 'Data Ins.', 'Visibile'],
            g_colonneNoOrder: [], 
            g_colonneAlign: [
                // {column: 'npartecipanti', align: 'text-center'}, 
                // {column: 'cor_npartecipanti_max', align: 'text-center'}
            ],
            g_comandi: 
            [
                {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-xs btn-outline-danger', emetti: 'Cancella'},
                // {titolo:'Duplica', icona:'fa-clone', iconaStile: 'btn btn-xs btn-outline-primary', emetti: 'Duplica'},
            ],
            g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
            g_currentPage: 1, //pagina corrente

            //Oggetto richiesta griglia
            reqGrigliaQuestionari: {
                ele_pag: 10,
                start: 0,
                orderColumn: "que_data",
                orderDir:"DESC",
                token: this.$store.state.UserInfo.token,
                //Campi custom
                Testuale: "",
                
            },

            oQuestionario: {
                que_idq: -1,
                que_visib: false,
                que_arch: "",
                que_cancellato: "",
                que_nome: "",
                que_testo: "",
                que_documento: "n/d",
                que_doctype: "",
                que_data: "",
                que_quiz: false,
                que_tempo: 0,
                que_errori: 0,
                que_ore: 1,
                que_tipo: 1,
                que_domande: 10,
                que_risp_passaggio: 8,
                domande: [{
                    qdo_idd: -1,
                    qdo_testo: "",
                    qdo_idq: -1,
                    qdo_ordine: 1,
                    risposte: [
                        {
                            qri_idr: -1,
                            qri_idd: -1,
                            qri_testo: "",
                            qri_valore: false,
                            ari_ordine: 1
                        }
                    ]
                }],

                token: "",
            },

          
         

            mostraGrigliaQuestionari: true,
            mostraEditQuestionario: false,

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false
                      
        
        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
        AttivaGriglia() {
            this.mostraEditQuestionario = false;
            this.mostraGrigliaQuestionari = true;

            this.GetListQuestionari();
        },
        AzzeraFiltri() {
            this.reqGrigliaQuestionari.Testuale = "";
            this.GetListQuestionari();
        },
        AttivaEditQuestionario() {
            this.mostraEditQuestionario = true;
            this.mostraGrigliaQuestionari = false;
            
            this.ClearMessaggio();
            this.ClearQuestionario();

        },
        ClearQuestionario() {
            this.oQuestionario = {
                que_idq: -1,
                que_visib: false,
                que_arch: "",
                que_cancellato: "",
                que_nome: "",
                que_testo: "",
                que_documento: "n/d",
                que_doctype: "",
                que_data: "",
                que_quiz: false,
                que_tempo: 0,
                que_errori: 0,
                que_ore: 1,
                que_tipo: 1,
                que_domande: 10,
                que_risp_passaggio: 8,
                domande: [
                    /*{
                    qdo_idd: -1,
                    qdo_testo: "",
                    qdo_idq: -1,
                    qdo_ordine: 1,
                    risposte: [
                        {
                            qri_idr: -1,
                            qri_idd: -1,
                            qri_testo: "",
                            qri_valore: false,
                            ari_ordine: 1
                        }
                    ]
                    }*/
                ],

                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },

        // *** OPERAZIONI DI BASE SU QUESTIONARI
        GetListQuestionari() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Questionari/GetListQuestionari" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGrigliaQuestionari)
            }).then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                
                        // for(let i = 0; i<obj.moreJsonData.length; i++){
                         
                            
                        // }


                        this.dtQuestionari = obj.moreJsonData;
                        this.g_queryLength = parseInt(obj.dati[0], 10);
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                });
        },
        GetElemQuestionari(idelem) {
            //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/Questionari/GetElemQuestionari?token=" + this.$store.state.UserInfo.token + "&idQue=" + idelem)
            .then(response => response.json())
            .then(obj => {

                this.oQuestionario = obj;

                this.mostraGrigliaQuestionari=false;
                this.mostraEditQuestionario= true;

                this.$store.commit('Messaggio', {parms: [true, ['Questionario caricato.'], 'alert alert-success', 'fa-check', false, 2000]});


            });
        },
        //Esporta su Excel
        EsportaListaQuestionari() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&orderColumn=" + this.reqGrigliaQuestionari.orderColumn + "&orderDir=" + this.reqGrigliaQuestionari.orderDir +
                    "&Testuale=" + this.reqGrigliaQuestionari.Testuale;
            let url =this.cfg.apisrv + "/api/Questionari/EsportaListaQuestionari" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },
        //modifica questionario 
        SelectQuestionario(o)  {
            this.GetElemQuestionari(o.que_idq);
        },

        SalvaQuestionario(reload) {
            let oSubmit = [];
            oSubmit = this.oQuestionario;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Questionari/SalvaQuestionario", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        if(reload)  {
                            this.GetElemQuestionari(obj.dati[0]);
                        }
                        else {
                            //Fa redirect
                            this.AttivaGriglia();
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },

        DelElemQuestionari(e) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/Questionari/DelElemQuestionari?token=" + this.$store.state.UserInfo.token + "&idQue=" + e.que_idq)
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Eliminato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListQuestionari(); 
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }

        },

        /* *** EDIT QUESTIONARIO/DOMANDE/RISPOSTE *** */
        EliminaDomanda(ndx_d) {
            if(confirm("Vuoi eliminare la domanda?")) {
                this.oQuestionario.domande.splice(ndx_d, 1);
                for (let o = ndx_d; o < this.oQuestionario.domande.length; o++) {
                    this.oQuestionario.domande[o].qdo_ordine--;
                }
            }
        },
        EliminaRisposta(ndx_d, ndx_r) {
            if(confirm("Vuoi eliminare la risposta?")) {
                this.oQuestionario.domande[ndx_d].risposte.splice(ndx_r, 1);
            }
        },
        NuovaDomanda() {
            let ndom = {
                qdo_idd: -1,
                qdo_testo: "",
                qdo_idq: this.oQuestionario.que_idq,
                qdo_ordine: this.oQuestionario.domande.length + 1,
                risposte: []}
            this.oQuestionario.domande.push(ndom);
            window.location.href="#aDomBottom";
        },
        NuovaRisposta(idd, ndx_d) {
            if(idd != -1) {
                let nris = {
                    qri_idr: -1,
                    qri_idd: idd,
                    qri_testo: "",
                    qri_valore: false,
                    qri_ordine: this.oQuestionario.domande[ndx_d].risposte.length + 1
                }
                this.oQuestionario.domande[ndx_d].risposte.push(nris);
            } else {
                this.$store.commit('Messaggio', {parms: [true, ['Salvare i dati prima di inserire le risposte.'], 'alert alert-danger', 'fa-times', false, 2000]});
            }
        },
        OrdinaDomanda(d, dir, ndx) {
            //console.log(dir);
            if (dir == 'up') {
                if (ndx != 0) {
                    this.oQuestionario.domande.splice(ndx, 1);
                    d.qdo_ordine--;
                    this.oQuestionario.domande.splice(ndx - 1, 0, d);
                    this.oQuestionario.domande[ndx].qdo_ordine++;
                }
            }
            if (dir == 'dn') {
                //console.log((ndx + 1) + ' ' + this.oQuestionario.domande.length)
                if ((ndx + 1) < this.oQuestionario.domande.length) {
                    //non va oltre la fine dell'array
                    this.oQuestionario.domande.splice(ndx, 1);
                    d.qdo_ordine++;
                    this.oQuestionario.domande.splice(ndx + 1, 0, d);
                    this.oQuestionario.domande[ndx].qdo_ordine--;
                    //for (let o = ndx + 1; o < this.oQuestionario.domande.length; o++) {
                    //    this.oQuestionario.domande[o].agd_ordine++;
                    //}
                }
                
            }
        },
      
       
      
    
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListQuestionari();

             

    }
}
</script>